import "./sizeable_icon.scss"

export default function GoogleOnColorIcon({ height, width, iconStyles }) {
  return (
    <svg
      styleName={iconStyles}
      width={width}
      height={height}
      viewBox="0 0 256 262"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        d="M253.1 106.8H130.5v48.4h71.9c-1.5 12-9.3 30.2-26.7 42.4-11 7.7-25.8 13.1-45.3 13.1-34.5 0-63.8-22.8-74.3-54.2-2.8-8.1-4.4-16.8-4.4-25.8s1.6-17.7 4.2-25.8C66.7 73.3 96 50.5 130.5 50.5c24.5 0 41.1 10.6 50.5 19.4l36.8-36c-22.6-21-52-33.9-87.3-33.9-51 0-95.1 29.3-116.6 71.9C5.1 89.6 0 109.5 0 130.5s5.1 40.9 13.9 58.6C35.4 231.7 79.5 261 130.5 261c35.2 0 64.8-11.6 86.5-31.6 24.7-22.8 38.9-56.3 38.9-96 0-10.7-.9-18.5-2.8-26.6z"
      />
    </svg>
  )
}

GoogleOnColorIcon.defaultProps = {
  width: 16,
  height: 16,
  iconStyles: "icon",
}
